import { useEffect, useState } from 'react';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [tooltip, setTooltip] = useState({ show: false, text: '' });
  const [hoverTimer, setHoverTimer] = useState(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const handleMouseOver = (e) => {
      const target = e.target.closest('[data-robot-tooltip]');
      
      // Clear any existing timer
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        setHoverTimer(null);
      }

      if (target) {
        const tooltipText = target.getAttribute('data-robot-tooltip');
        
        // Set a timer to show tooltip after 2 seconds
        const timer = setTimeout(() => {
          setTooltip({ show: true, text: tooltipText });
        }, 2000);
        
        setHoverTimer(timer);
      } else {
        setTooltip({ show: false, text: '' });
      }
    };

    const handleMouseOut = (e) => {
      const target = e.target.closest('[data-robot-tooltip]');
      if (target) {
        if (hoverTimer) {
          clearTimeout(hoverTimer);
          setHoverTimer(null);
        }
        setTooltip({ show: false, text: '' });
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleMouseOver);
    window.addEventListener('mouseout', handleMouseOut);

    return () => {
      if (hoverTimer) clearTimeout(hoverTimer);
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleMouseOver);
      window.removeEventListener('mouseout', handleMouseOut);
    };
  }, [hoverTimer]);

  if (!tooltip.show) return null;

  return (
    <div
      className="tooltip-wrapper"
      style={{
        left: `${position.x + 15}px`,
        top: `${position.y - 10}px`,
      }}
    >
      {/* Simple Tooltip - no orb */}
      <div className="simple-tooltip">
        <div className="simple-tooltip-arrow"></div>
        <div className="simple-tooltip-content">
          {tooltip.text}
        </div>
      </div>
    </div>
  );
};

export default CustomCursor;
